var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('insure-care-policy-info'),(_vm.policies.length > 0)?_c('paper-policies'):_vm._e(),_c('new-quote')],1)}
var staticRenderFns = []

export { render, staticRenderFns }